import { render, staticRenderFns } from "./calendarSettings.vue?vue&type=template&id=383fcc57"
import script from "./calendarSettings.vue?vue&type=script&lang=js"
export * from "./calendarSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports